import React, { useState } from 'react';

import { twMerge } from 'tailwind-merge';
import type { Dayjs } from 'dayjs';

import TimeInput from 'components/time-input/time-input';
import Typography from 'components/typography/typography';

interface TimeRangeInputProps {
  className?: string;
  defaultValue?: [Dayjs?, Dayjs?];
  onChange?: (value: [Dayjs?, Dayjs?]) => void;
  separator?: string;
  disabled?: boolean;
  hasError?: boolean;
  minuteStep?: number;
}

const TimeRangeInput: React.FC<TimeRangeInputProps> = (props) => {
  const {
    className,
    defaultValue,
    onChange,
    separator,
    disabled,
    hasError,
    minuteStep,
  } = props;

  const [timeRange, setTimeRange] = useState<{
    start?: Dayjs;
    end?: Dayjs;
  }>({
    end: defaultValue?.[1],
    start: defaultValue?.[0],
  });

  const onTimeRangeChange = (target: { name: string; value?: Dayjs }) => {
    const { name, value } = target;
    const newValues = {
      ...timeRange,
      [name]: value,
    };
    onChange?.([newValues.start, newValues.end]);
    setTimeRange(newValues);
  };

  return (
    <div className={twMerge('flex gap-x-4', className)}>
      <TimeInput
        name="start"
        onChange={onTimeRangeChange}
        value={timeRange.start}
        disabled={disabled}
        hasError={hasError}
        minuteStep={minuteStep}
      />
      {separator && (
        <Typography variant="body-medium" as="p">
          {separator}
        </Typography>
      )}
      <TimeInput
        name="end"
        onChange={onTimeRangeChange}
        value={timeRange.end}
        disabled={disabled}
        hasError={hasError}
        minuteStep={minuteStep}
      />
    </div>
  );
};

export default TimeRangeInput;
